export default [{
    path: '/mine/changePassword',
    name: 'changePassword',
    meta: {
      index: 14
    },
    component: () => import('@/views/mine/changePassword.vue')
  }]
  